export enum COLORS {
  DarkBackground = "#131B2D",
  White = "#FFFFFF",
  Orange = "#FA824C",
  DodgerBlue = "rgba(58, 146, 250, 0.7)",
  Black = "#000000",
}

//fonts
export enum FONTS {
  JetBrains = "JetBrains Mono",
}

//weight
